import { callApi } from "./callApi";
window.e9TimeOutSwitch = false;
function initTimeoutSwitch() {
  callApi("/api/hrm/login/getTimeOutSwitch", "GET", {}).then(res => {
    if (res.status == "1" && res.isNeedDialog == "false") {
      window.e9TimeOutSwitch = true;
    }
  });
}
module.exports = initTimeoutSwitch;



// WEBPACK FOOTER //
// ./ecology9/wea-tools/timeoutSwitch.js